import * as services from '@services/index';
import { IFeedbackQuestionTransform } from '@/schemas/feedback';

interface IState {
  questionsData: IFeedbackQuestionTransform[];
}

const initState: IState = {
  questionsData: [] as IFeedbackQuestionTransform[]
};

const feedback = {
  state: initState,

  reducers: {
    updateQuestionsData(state: IState, payload: IFeedbackQuestionTransform[]) {
      return {
        ...state,
        questionsData: payload
      };
    }
  },
  effects: (dispatch) => ({
    async getCommonProblems() {
      try {
        const res = await services.feedback.getCommonProblems();
        this.updateQuestionsData(res);
      } catch (err) {
        //
      }
    }
  })
};

export default feedback;
